import { RouteConfig, Route } from 'vue-router';
import toggleFullScreen from '@app/functions/toggleFullscreen';
import { getModule as getStoreModule } from 'vuex-module-decorators';
import AppStoreModule from '../store/modules/AppStoreModule';
import AppModule from '../types/base/AppModule';
import { authenticationGuard } from './auth';

const appStore: AppStoreModule = getStoreModule(AppStoreModule);

export async function getRoutes(): Promise<RouteConfig[]> {
	const routes: RouteConfig[] = [
		{
			path: '/present/:id/:slideId?',
			name: 'present',
			component: (): any => import('@modules/present/PresentModule.vue'),
			children: [],
			beforeEnter: async (to: Route, from: Route, next: (route?: any) => void): Promise<void> => {
				appStore.setActiveAppModule(AppModule.Present);
				await toggleFullScreen(true);
				authenticationGuard(to, from, next);
			}
		}
	];

	return routes;
}
